const digest = '37a46dbc890429ec1d16d118701b5f23cc11e673cdbf8301b82c6fee2a47993f';
const css = `._radiusOverride_1pxzd_1 [data-testid=article-card]>div{border-radius:1rem!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'radiusOverride': '_radiusOverride_1pxzd_1' };
export const radiusOverride = '_radiusOverride_1pxzd_1';
export { css, digest };